/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import "react-calendar/dist/Calendar.css";

///Images

//Import
import { ThemeContext } from "../../../context/ThemeContext";
import { axiosInstance } from "../../../services/AxiosInstance";

const Home = () => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const getUser = () => {
    setLoader(true);
    axiosInstance
      .get("admin/users")
      .then(function (response) {
        console.log(response, "Getting Compaines");
        if (response?.data.status === true) {
          setData(response?.data.data);

          setLoader(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };

  const { changeBackground } = useContext(ThemeContext);
  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
    getUser();
  }, []);
  return (
    <>
      {loader ? <div className="loader" /> : null}
      <div className="row">
        <div className="col-xl-6 col-sm-6">
          <div className="card gradient-1 card-bx">
            <div className="card-body d-flex align-items-center">
              <div className="me-auto text-white">
                <h2 className="text-white">{data?.length}</h2>
                <span className="fs-18">User</span>
              </div>
              <img src="/img/group.png" width={"45%"} alt="" />
            </div>
          </div>
        </div>
        <div className="col-xl-6 col-sm-6">
          <div className="card gradient-2 card-bx">
            <div className="card-body d-flex align-items-center">
              <div className="me-auto text-white">
                <h2 className="text-white">
                  {data?.filter((s) => s.status === 1).length}
                </h2>
                <span className="fs-18">Active User</span>
              </div>
              <img src="/img/add-friend.png" width={"45%"} alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
